import { Select } from "antd";
import style from "./style.module.scss";
import React, { useEffect, useState } from "react";
import { GlobalRequest } from "../../services/request";
import { HttpStatusCode } from "axios";
import Spinner from "../Spinner/Spinner";

type ValueType = {
  label: string;
  value: string | number;
};

type PropsType = React.InputHTMLAttributes<HTMLInputElement> & {
  value?: ValueType | string | number | null;
  className?: string;
  onChange: (e: any) => void;
  onGetAllValue?: (e: any) => void;
  uri: string;
  params?: any;
  isNotUri?: boolean;
  disabled?: boolean;
  valueOption?: {
    labelKey: string | ((item: any) => string);
    valueKey: string;
    title?: string;
  };
  mode?: "multiple" | "single";
  allowClear?: boolean;
  excludedValue?: Array<string | number>;
};

const defaultParams = {
  itemsPerPage: 9999,
};

export const InputSelect = ({
  className,
  onChange,
  onGetAllValue,
  uri,
  params,
  isNotUri,
  valueOption,
  value,
  disabled,
  mode,
  allowClear = true,
  excludedValue,
}: PropsType) => {
  const labelKey = valueOption ? valueOption?.labelKey : "name";
  const valueKey = valueOption
    ? valueOption?.valueKey
    : isNotUri
    ? "id"
    : "@id";

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [defaultValue, setDefaultValue] = useState<any>(value);

  const [options, setOptions] = useState<Array<any>>([]);

  const [timeoutId, setTimeoutId] = useState<any>(null);

  useEffect(() => {
    getOptions(uri, params);
  }, [uri, params]);

  useEffect(() => {
    setDefaultValue(value);
  }, [value]);

  // useEffect(() => {
  //   setFinalExcludedOptions(getExcludedValue());
  // }, [defaultValue, excludedValue]);

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const onTypingOnSearch = (value: any) => {
    setIsLoading(true);
    setOptions([]);
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const id = setTimeout(() => {
      getOptions(uri, { [String(labelKey)]: value });
    }, 300);
    setTimeoutId(id);
  };

  const getOptions = async (uri: string, par?: any) => {
    setIsLoading(true);
    setOptions([]);
    try {
      const res = await GlobalRequest.get(uri, {
        ...defaultParams,
        ...params,
        ...par,
      });
      if (res?.status === HttpStatusCode.Ok) {
        const excluded = excludedValue ? [...excludedValue] : [];
        if (Array.isArray(res?.data?.member)) {
          const optionsResult = res?.data?.member
            ?.map((item: any) => ({
              ...item,
              key: item?.id,
              label:
                typeof labelKey === "function"
                  ? labelKey(item)
                  : item?.abbreviation ?? item?.[labelKey],
              value: item?.[valueKey],
              ...(valueOption?.title
                ? {
                    title: item?.[valueOption?.title],
                  }
                : {}),
            }))
            ?.filter((elem: any) => !excluded?.includes(elem?.value));
          setOptions(optionsResult);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e: any) => {
    onChange(e);
    const finded = options?.find((item) => item?.id === e?.key);
    onGetAllValue && onGetAllValue(finded);
  };

  return (
    <>
      <Select
        className={` ${className} `}
        labelInValue
        value={defaultValue}
        loading={isLoading}
        onChange={handleChange}
        options={options}
        allowClear={allowClear}
        disabled={disabled}
        showSearch
        optionFilterProp="label"
        onSearch={onTypingOnSearch}
        {...(mode === "multiple" ? { mode: "multiple" } : {})}
        {...(isLoading
          ? {
              notFoundContent: (
                <div className="w-100 d-flex justify-content-center">
                  <Spinner color="#6b7280" />
                </div>
              ),
            }
          : "")}
      />
    </>
  );
};
